import React from 'react';
import { RulerIcon, MapIcon, ClipboardCheckIcon, CameraIcon, LayersIcon } from 'lucide-react';
import { CTAButton } from '../CTAButton';
import { learningTools } from '../../data/content';
const icons = [RulerIcon, MapIcon, ClipboardCheckIcon, CameraIcon, LayersIcon];
export function LearningTools() {
  return <section className="w-full bg-white px-4 py-16 sm:py-20" aria-labelledby="tools-heading" data-id="element-199" data-mp="3luom4zmu4h2n">
      <div className="mx-auto max-w-4xl" data-id="element-200" data-mp="2y5418b74f9qq">
        <p className="text-center font-display text-sm font-extrabold uppercase tracking-widest text-gold-600" data-id="element-201" data-mp="2y65emmbm08bm">More than just 6 ebooks</p>
        <h2 id="tools-heading" className="mt-3 text-center font-display text-[1.7rem] font-black leading-tight text-navy-950 sm:text-4xl" data-id="element-202" data-mp="382ryp8w42vcl">
          Practical Clinical Resources You Can Actually Use
        </h2>
        <p className="mx-auto mt-4 max-w-xl text-center text-base text-ink/70" data-id="element-203" data-mp="nb85y1ik0hpb">SMILE DESIGN ROADMAP™ is designed around five practical learning tools.</p>

        <ul className="mt-10 divide-y divide-navy-900/10 border-y border-navy-900/10" data-id="element-204" data-mp="if9c3yegi7hi">
          {learningTools.map((tool, i) => {
          const Icon = icons[i];
          return <li key={tool.title} className="flex gap-4 py-5" data-id="element-205" data-mp="2b00262iw4w4f" data-mpi={i}>
                <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-navy-900 text-gold-300" data-id="element-206" data-mp="2fybdkhou3eor">
                  <Icon className="h-6 w-6" aria-hidden="true" data-id="element-207" data-mp="2jwhidk643k71" />
                </span>
                <div data-id="element-208" data-mp="1n9vyxw9m6ydy">
                  <h3 className="font-display text-lg font-extrabold text-navy-950" data-id="element-209" data-mp="1n6hxqrcosv83">{tool.title}</h3>
                  <p className="mt-1 text-[15px] leading-relaxed text-ink/75" data-id="element-210" data-mp="1s51kgtz3ub1i">{tool.body}</p>
                </div>
              </li>;
        })}
        </ul>

        <p className="mx-auto mt-8 max-w-2xl text-center text-base font-medium text-navy-900" data-id="element-211" data-mp="211aji7j677n4">
          Everything is designed to make complex concepts easier to review, understand, and apply responsibly.
        </p>
        <div className="mt-8" data-id="element-212" data-mp="18hc037thzd2b">
          <CTAButton label="Get instant access to all 6 volumes" sublabel="Charts, maps, checklists & guides included" data-id="element-213" data-mp="2bu2nv2wlutdz" />
        </div>
      </div>
    </section>;
}